import { Injectable, Inject, Optional } from '@angular/core';
import { Router, UrlTree, CanActivate } from '@angular/router';

import { ORGANIZATION_PREFIX } from '../providers';

@Injectable({ providedIn: 'root' })
export class HasOrganizationPrefix implements CanActivate {
  constructor(
    private readonly _router: Router,
    @Optional() @Inject(ORGANIZATION_PREFIX) private readonly _prefix?: string,
  ) {}

  public canActivate(): boolean | UrlTree {
    return !!this._prefix || this._getRedirectUnauthorizedTo();
  }

  private _getRedirectUnauthorizedTo(): UrlTree {
    return this._router.createUrlTree([]);
  }
}
